import { media, styled } from '@styles';

export const Wrapper = styled.div`
  max-width: 342px;
  padding: 40px;
  margin: 0 auto;
  width: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  color: #f5f1f2;
  z-index: 0;
  ${media.largeScreen`
    padding: 36px;
    // max-width: 273px;
  `}
  ${media.mediumScreen`
    padding: 24px;
    max-width: 100%;
  `}
  ${media.xSmallScreen`
    padding: 10px;
  `}
`;

export const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
export const Title = styled.div<{ reverse: boolean }>`
  font-weight: 300;
  line-height: 100%;
  color: ${({ reverse, theme: { colors } }) =>
    reverse ? colors.black : colors.white};
  font-family: ${(props) => props.theme.typography.thinFontFamily};
  font-size: ${(props) => props.theme.typography.h4FontSize};
  text-transform: capitalize;
  text-align: left;
  & em {
    color: ${(props) => props.theme.colors.red};
  }
`;

export const Button = styled.div`
  text-align: center;
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  width: 88%;
  font-size: ${(props) => props.theme.typography.labelFontSize};
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #000000;
  opacity: 0.3;
  z-index: -1;
`;
